/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import emptiness from 'shared/ui/mixins/common/emptiness';

/**
 * ExpandableContent component, used to display content when user clicks on the header's toggler.
 *
 * @example
 * expandable-content(togglerText="i18n.see_more.key")
 *      div(slot="header")
 *          strong My header content
 *      div
 *          p my content
 *
 * @vue-prop {String} [togglerText] an optional i18n key for the toggler.
 * @vue-prop {String} [contentClass=''] an optional class to add to the content block.
 * @vue-prop {Boolean} [clickableHeader=false] whether the header should act as a toggler or not.
 * @vue-prop {Boolean} [showToggler=true] whether to show the toggler or not.
 *
 * @category ui.components
 * @exports ExpandableContent
 * @component
 */

const __vue_script__ = {
    name: 'ExpandableContent',

    mixins: [emptiness],

    props: {
        index: {
            type: Number,
            default: 0
        },

        togglerText: {
            type: String,
            default: ''
        },

        openTogglerText: {
            type: String,
            default: ''
        },

        contentClass: {
            type: String,
            default: ''
        },

        clickableHeader: {
            type: Boolean,
            default: false
        },

        showToggler: {
            type: Boolean,
            default: true
        },

        isOpen: {
            type: Boolean,
            default: false
        },

        unlimitedHeight: {
            type: Boolean,
            default: false
        },

        animated: {
            type: Boolean,
            default: false
        },

        slim: {
            type: Boolean,
            default: false
        },

        hideHeader: {
            type: Boolean,
            default: false
        },

        focused: {
            type: Boolean,
            default: false
        },

        hideIfNoChildren: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            open: this.isOpen,
            ref: 'content',
            closedText: this.togglerText,
            openedText: this.openTogglerText || this.togglerText
        };
    },

    computed: {
        empty() {
            return !this.$scopedSlots.default;
        },

        showExpandToggler() {
            return this.showToggler && !this.empty;
        },

        visible() {
            return !this.hideIfNoChildren || !this.hasNoChildren;
        },

        hasActions() {
            const slot = this.$scopedSlots['actions'];
            return slot && !!slot();
        }
    },

    watch: {
        isOpen() {
            this.open = this.isOpen;
        },

        focused() {
            this.attemptFocus();
        }
    },

    mounted() {
        this.attemptFocus();
    },

    methods: {
        attemptFocus() {
            if (this.focused) {
                this.$el?.focus();
                this.toggleOpen(true);
            }
        },

        openFromToggler() {
            if (!this.clickableHeader) {
                this.toggleOpen();
            }
        },

        openFromHeader() {
            if (this.clickableHeader) {
                this.toggleOpen();
            }
        },

        toggleOpen(forceOpen = false) {
            if (!this.empty) {
                this.open = forceOpen || !this.open;
                this.$emit('toggle', this.open, this.index);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"expandable",class:{ open: _vm.open, 'unlimited-height': _vm.unlimitedHeight, 'not-empty': !_vm.empty, animated: _vm.animated, slim: _vm.slim }},[(!_vm.hideHeader)?_c('header',{class:{'has-action': !_vm.empty && _vm.clickableHeader},attrs:{"tabindex":"0"},on:{"click":_vm.openFromHeader,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.openFromHeader.apply(null, arguments)}}},[_vm._t("header",null,{"open":_vm.open}),(_vm.hasActions || _vm.showExpandToggler)?_c('div',{staticClass:"ctx"},[(_vm.showExpandToggler)?_c('div',{staticClass:"toggler",attrs:{"tabindex":"0"},on:{"click":_vm.openFromToggler}},[_vm._t("toggler",function(){return [_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.open ? _vm.$t(_vm.openedText) : _vm.$t(_vm.closedText)))]),_c('i',{staticClass:"ic-chevron-down"})]})],2):_vm._e(),(_vm.hasActions)?_c('div',{staticClass:"actions"},[_vm._t("actions")],2):_vm._e()]):_vm._e()],2):_vm._e(),_c('section',{ref:"content",class:_vm.contentClass},[_vm._t("default",null,{"isOpen":_vm.open})],2),_vm._t("footer",null,{"open":_vm.open,"toggleOpen":function () { return _vm.toggleOpen(); }})],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ExpandableContent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__